import React, { useState } from 'react';
import { message } from 'antd';
import dayjs from 'dayjs';
import webStorage from '@/utils/storageManager';
import { useDispatch } from 'umi';
import {
  RadioGroup,
  Radio,
  Select,
  MenuItem,
  TextField,
  Button,
  FormControlLabel,
  // Box,
} from '@material-ui/core';
import { download } from '@/utils/downloadUtil';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import FileDownloadIcon from '@material-ui/icons/GetApp';
import DataToolsStyled from './IndexStyled.js';

const getDictValue = (data, type) => {
  if (!data) {
    return '';
  }
  const d = data.filter((item) => item.dictCode === type)[0] || {};
  return d.dictValue;
};

const FilterSection = ({
  filters,
  setFilters,
  // onQuery,
  onExport,
  onReset,
  // isQuerying,
}) => {
  const TRACK_APP_ID = webStorage.get('DICTOBJ')?.TRACK_APP_ID;
  const APP_OPTIONS = [
    { value: getDictValue(TRACK_APP_ID, 'SMG Stage Meet'), label: '台上见' },
    { value: getDictValue(TRACK_APP_ID, 'LOL ARCANE'), label: '双城之战' },
  ];

  const ORDER_TYPE_OPTIONS = [
    { value: '票务', label: '剧目订单' },
    { value: '商城', label: '商城订单' },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="filter-section">
      <div className="filter-header">
        <h2>筛选条件</h2>
      </div>

      <div className="filter-content">
        <div className="filter-group">
          <div className="filter-item">
            <div className="filter-label">
              订单类型 <span className="required">*</span>
            </div>
            <div className="filter-row">
              <RadioGroup
                name="orderType"
                value={filters.orderType}
                onChange={handleInputChange}
                // variant="standard"
                className="filter-radio-group"
              >
                {ORDER_TYPE_OPTIONS.map((opt) => (
                  <FormControlLabel
                    key={opt.value}
                    value={opt.value}
                    control={<Radio />}
                    label={opt.label}
                  />
                ))}
              </RadioGroup>
            </div>
          </div>
          <div className="filter-item">
            <div className="filter-label">
              小程序 <span className="required">*</span>
            </div>
            <div className="filter-row">
              <Select
                name="miniProgram"
                value={filters.miniProgram}
                onChange={handleInputChange}
                variant="standard"
                className="filter-select"
              >
                {APP_OPTIONS.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>

          <div className="filter-item">
            <div className="filter-label">
              时间范围 <span className="required">*</span>
            </div>
            <div className="filter-row">
              <TextField
                type="date"
                name="startDate"
                value={filters.startDate}
                onChange={handleInputChange}
                variant="standard"
                size="small"
                className="filter-input"
              />
              <span className="date-separator">至</span>
              <TextField
                type="date"
                name="endDate"
                value={filters.endDate}
                onChange={handleInputChange}
                variant="standard"
                size="small"
                className="filter-input"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="filter-footer">
        <Button onClick={onReset}>
          <RotateRightIcon />
          重置
        </Button>
        <Button onClick={onExport} color="primary">
          <FileDownloadIcon />
          导出
        </Button>
      </div>
    </div>
  );
};

const DataTools = () => {
  const dispatch = useDispatch();
  const TRACK_APP_ID = webStorage.get('DICTOBJ')?.TRACK_APP_ID;
  const APP_OPTIONS = [
    { value: getDictValue(TRACK_APP_ID, 'SMG Stage Meet'), label: '台上见' },
    { value: getDictValue(TRACK_APP_ID, 'LOL ARCANE'), label: '双城之战' },
  ];

  const defaultFilters = {
    orderType: '票务', // 1:剧目订单 2:商城订单
    startDate: dayjs().format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD'),
    miniProgram: getDictValue(TRACK_APP_ID, 'SMG Stage Meet'),
  };

  const [filters, setFilters] = useState(defaultFilters);

  // 表单校验
  const validateForm = () => {
    const startD = dayjs(filters.startDate);
    const endD = dayjs(filters.endDate);

    if (!startD || !endD) {
      message.error('请输入有效的日期');
      return false;
    }

    const daysDiff = (endD - startD) / (1000 * 60 * 60 * 24);
    if (daysDiff > 90) {
      message.error('时间范围不能超过90天');
      return false;
    }
    if (daysDiff < 0) {
      message.error('开始时间不能晚于结束时间');
      return false;
    }
    return true;
  };

  const handleReset = () => {
    setFilters(defaultFilters);
    dispatch({
      type: 'dataTools/save',
      payload: {
        trackingData: {},
      },
    });
  };

  const handleExport = () => {
    if (!validateForm()) {
      return;
    }

    const appName =
      APP_OPTIONS.find((opt) => opt.value === filters.miniProgram)?.label || '';
    const values = {
      appId: filters.miniProgram,
      appName,
      type: filters.orderType,
      startDate: filters.startDate,
      endDate: filters.endDate,
    };

    Object.keys(values).forEach((key) => {
      if (!values[key]) {
        delete values[key];
      }
    });

    message.success('数据下载中...');
    download('/activity-data/invoice/export', values);
  };

  return (
    <DataToolsStyled>
      {/* <div className="page-header">
        <h1>活动数据取数工具</h1>
        <p>快速查询并导出用户活动数据。</p>
      </div> */}

      <FilterSection
        filters={filters}
        setFilters={setFilters}
        // onQuery={handleQuery}
        onExport={handleExport}
        onReset={handleReset}
      />
    </DataToolsStyled>
  );
};

export default DataTools;
